import React from "react";

const Focus = () => {
  return (
    <div>
      <h2 className="mt-35" style={{ backgroundColor: "#3f4db6" }}>
      A lot of elements have to come together to create success for our clients.
      </h2>
      <div className="row justify-content-center section-title mt-25">
        <div className="col-md ">
          <p>
            <large>
              <strong>
                <em>To be the most preferred software development company</em>
              </strong>
            </large>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Focus;
